import { render } from "./BlogPosts.vue?vue&type=template&id=71a46756&scoped=true"
import script from "./BlogPosts.vue?vue&type=script&lang=js"
export * from "./BlogPosts.vue?vue&type=script&lang=js"

import "./BlogPosts.vue?vue&type=style&index=0&id=71a46756&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a46756"]])

export default __exports__